import React from "react";

const HairScalpTreatmentProcess = () => {
  return (
    <div className="hairSalonInSahakaraWhat">
      <h3>Benefits of Our Hair Scalp Treatment</h3>
      <li>
        <h6>1.Consultation and Diagnosis</h6>
        <p>
          Our specialists perform a thorough analysis to understand your scalp’s
          condition.{" "}
        </p>
        <p>
          We discuss your concerns, lifestyle, and hair care routine to design a
          tailored treatment plan.
        </p>
      </li>
      <li>
        <h6> 2. Deep Cleansing</h6>
        <p>
          Removal of dirt, excess oil, and product buildup to ensure your scalp
          is clean and healthy.
        </p>
      </li>
      <li>
        <h6> 3. Exfoliation</h6>
        <p>
          Gentle exfoliation to eliminate dead skin cells and unclog hair
          follicles.
        </p>
      </li>
      <li>
        <h6>4. Nourishment</h6>
        <p>
          Application of nutrient-rich masks or serums to nourish the scalp and
          strengthen hair roots.
        </p>
      </li>
      <li>
        <h6> 5. Therapeutic Massage:</h6>
        <p>
          Relaxing massage to improve blood circulation and promote hair growth.
        </p>
      </li>
      <li>
        <h6> 6. Advanced Therapies</h6>
        <p>
          Use of technologies like LED light therapy or micro-needling, based
          on your scalp’s needs.
        </p>
      </li>
    </div>
  );
};

export default HairScalpTreatmentProcess;
